import { constants } from '..';

const APPLICATIONS_INITIAL_STATE = {
  loading: false,
  applications: [],
};

const DEVICES_INITIAL_STATE = {
  loading: false,
  devices: [],
  total: 0,
};

const LOGS_INITIAL_STATE = {
  loading: false,
  logs: [],
  total: 0,
  header: {},
  logsExport: {},
};

const SCHEDULED_ACTION_LOGS_INITIAL_STATE = {
  loading: false,
  scheduledActionLogs: [],
  total: 0,
  header: {},
};

const INITIAL_STATE = {
  loading: false,
  monitoring: {},
  availabilityDevices: null,
  availabilityDevicesByPeriod: null,
  applications: APPLICATIONS_INITIAL_STATE,
  devices: DEVICES_INITIAL_STATE,
  logs: LOGS_INITIAL_STATE,
  scheduledActionLogs: SCHEDULED_ACTION_LOGS_INITIAL_STATE,
  deviceAnalytics: null,
};

export const monitoringReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.monitoring.SET_MONITORING_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.monitoring.SET_MONITORING:
      return {
        ...state,
        monitoring: action.monitoring,
      };
    case constants.monitoring.SET_APPLICATIONS_LOADING:
      return {
        ...state,
        applications: {
          ...state.applications,
          loading: action.flag,
        },
      };
    case constants.monitoring.SET_APPLICATIONS:
      return {
        ...state,
        applications: {
          ...state.applications,
          applications: action.applications,
        },
      };
    case constants.monitoring.SET_AVAILABILITY_DEVICES:
      return {
        ...state,
        availabilityDevices: action.availabilityDevices,
      };
    case constants.monitoring.CLEAR_AVAILABILITY_DEVICES:
      return {
        ...state,
        availabilityDevices: null,
      };
    case constants.monitoring.SET_AVAILABILITY_DEVICES_BY_PERIOD:
      return {
        ...state,
        availabilityDevicesByPeriod: action.availabilityDevicesByPeriod,
      };
    case constants.monitoring.CLEAR_AVAILABILITY_DEVICES_BY_PERIOD:
      return {
        ...state,
        availabilityDevicesByPeriod: null,
      };
    case constants.monitoring.CLEAR_APPLICATIONS:
      return {
        ...state,
        applications: APPLICATIONS_INITIAL_STATE,
      };
    case constants.monitoring.SET_DEVICES_LOADING:
      return {
        ...state,
        devices: {
          ...state.devices,
          loading: action.flag,
        },
      };
    case constants.monitoring.SET_DEVICES:
      return {
        ...state,
        devices: {
          ...state.devices,
          devices: action.devices,
          header: action.header,
          total: action.count,
        },
      };
    case constants.monitoring.CLEAR_DEVICES:
      return {
        ...state,
        devices: DEVICES_INITIAL_STATE,
      };
    case constants.monitoring.SET_LOGS_LOADING:
      return {
        ...state,
        logs: {
          ...state.logs,
          loading: action.flag,
        },
      };
    case constants.monitoring.SET_LOGS:
      return {
        ...state,
        logs: {
          ...state.logs,
          logs: action.logs,
          header: action.header,
          total: action.count,
        },
      };
    case constants.monitoring.SET_LOGS_EXPORT_IDENTIFIER:
      return {
        ...state,
        logs: {
          ...state.logs,
          logsExport: action.identifier,
        },
      };
    case constants.monitoring.CLEAR_LOGS:
      return {
        ...state,
        logs: LOGS_INITIAL_STATE,
      };
    case constants.monitoring.SET_SCHEDULED_ACTION_LOGS_LOADING:
      return {
        ...state,
        scheduledActionLogs: {
          ...state.scheduledActionLogs,
          loading: action.flag,
        },
      };
    case constants.monitoring.SET_SCHEDULED_ACTION_LOGS:
      return {
        ...state,
        scheduledActionLogs: {
          ...state.scheduledActionLogs,
          scheduledActionLogs: action.scheduledActionLogs,
          header: action.header,
          total: action.count,
        },
      };
    case constants.monitoring.CLEAR_SCHEDULED_ACTION_LOGS:
      return {
        ...state,
        scheduledActionLogs: SCHEDULED_ACTION_LOGS_INITIAL_STATE,
      };
    case constants.monitoring.CLEAR_MONITORING:
      return {
        ...INITIAL_STATE,
        devices: state.devices,
        applications: state.applications,
        logs: state.logs,
        scheduledActionLogs: state.scheduledActionLogs,
      };
    case constants.monitoring.SET_DEVICE_ANALYTICS:
      return {
        ...state,
        deviceAnalytics: action.analytics,
      };
    case constants.monitoring.CLEAR_DEVICE_ANALYTICS:
      return {
        ...state,
        deviceAnalytics: null,
      };
    default:
      return state;
  }
};
